import { useMemo } from 'react';
import { useCorporateBondScreenerDictionariesContext } from '@/creditflowresearch/application/CorporateBondScreener/CorporateBondScreenerDictionariesContext';
import { TableDictionariesProvider } from '@/creditflowresearch/application/TableDictionaries';
import { BondScreenerTable } from '@/creditflowresearch/ui/common/components/DataTable/BondScreenerTable';
import type { ICorporateBondScreenerTrancheRow } from '@/creditflowresearch/application/CorporateBondScreener/useCorporateBondScreener';
import { useDynamicColumns } from '../Table/hooks/useDynamicColumns';
import { useMySelectionSync } from './useMySelectionSync';

export const MySelectionTab = () => {
  const dictionaries = useCorporateBondScreenerDictionariesContext();
  const { selectedItems } = useMySelectionSync();
  const resolvedColumns = useDynamicColumns(selectedItems);

  const columns = useMemo(
    () => resolvedColumns.map((col) => ({ ...col, sortable: false })),
    [resolvedColumns],
  );

  return (
    <TableDictionariesProvider dictionaries={ dictionaries }>
      <BondScreenerTable<ICorporateBondScreenerTrancheRow>
        dataTest="corporateBondScreenerMySelectionTable"
        columns={ columns }
        data={ selectedItems }
        emptyMessage="No records selected"
      />
    </TableDictionariesProvider>
  );
};
